// RecurrenceBadge: Compact badge indicating the recurrence frequency of a mission
// Shown for all recurring missions; not shown for one-time (non-recurring) missions
// CREATED: Part of the agenda list view for TeamView

interface RecurrenceBadgeProps {
  frequency: 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
  interval: number;
}

function getLabel(frequency: 'daily' | 'weekly' | 'monthly' | 'yearly', interval: number): string {
  switch (frequency) {
    case 'yearly':
      return interval === 1 ? 'Annuelle' : `Tous les ${interval} ans`;
    case 'monthly':
      return interval === 1 ? 'Mensuelle' : `Tous les ${interval} mois`;
    case 'weekly':
      if (interval === 2) return 'Bi-hebdo';
      if (interval === 1) return 'Hebdomadaire';
      return `Toutes les ${interval} sem.`;
    case 'daily':
      return interval === 1 ? 'Quotidienne' : `Tous les ${interval}j`;
    default:
      return 'Récurrente';
  }
}

function getStyles(frequency: 'daily' | 'weekly' | 'monthly' | 'yearly', interval: number): string {
  switch (frequency) {
    case 'yearly':
      return 'bg-amber-50 text-amber-700 border border-amber-200';
    case 'monthly':
      return 'bg-sky-50 text-sky-700 border border-sky-200';
    case 'weekly':
      if (interval >= 2) return 'bg-gray-100 text-gray-600 border border-gray-200';
      return 'bg-gray-50 text-gray-500 border border-gray-200';
    case 'daily':
      return 'bg-gray-50 text-gray-400 border border-gray-100';
    default:
      return 'bg-gray-50 text-gray-500 border border-gray-200';
  }
}

export function RecurrenceBadge({ frequency, interval }: RecurrenceBadgeProps) {
  if (!frequency) return null;

  return (
    <span className={`inline-flex items-center text-[11px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap flex-shrink-0 ${getStyles(frequency, interval)}`}>
      {getLabel(frequency, interval)}
    </span>
  );
}
